import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const Time = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`suspiciousActivityInfo.ipAddresses.${index as 0}.time`}
      control={control}
      render={({ field }) => <FF2 label="Timestamp (UTC)" field={field} input={(props) => <TextInput {...props} />} />}
    />
  )
}
